import {GeneralAction} from "../../@types/actions";
import {EventStoredObject} from "../../@types/response";
import {EDIT_FIXTURES} from "../../constants/CommonConstants";

export const UpdateFixtureAction = (fixture: EventStoredObject): GeneralAction<any> => ({
    type: EDIT_FIXTURES,
    payload: {fixture}
});
